import { render, staticRenderFns } from "./SoftwareDocuments.vue?vue&type=template&id=66caba3e"
import script from "./SoftwareDocuments.vue?vue&type=script&lang=js"
export * from "./SoftwareDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports